export const AUTH_TOKEN_STORAGE_KEY = 'SY_WEB_AUTH_TOKEN';

export const getLocalAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_STORAGE_KEY) || '';
};

export const setAuthToken = (token: string) => {
  localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);

  if (!window.udid) {
    window.gettoken = getLocalAuthToken;
  }
};

export const clearAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);

  if (!window.udid) {
    window.gettoken = getLocalAuthToken;
  }
};

export const getAuthToken = () => {
  const appToken =
    typeof window.gettoken === 'function' ? window.gettoken() : '';

  if (appToken && appToken !== 'null') {
    return appToken;
  }

  return getLocalAuthToken();
};

export const setupLocalAuthTokenGetter = () => {
  if (typeof window.gettoken !== 'function') {
    window.gettoken = getLocalAuthToken;
  }
};
